import React, { type ReactElement, useEffect, useState } from 'react'
import Snackbar, { type SnackbarProps } from '@mui/material/Snackbar'
import Fade from '@mui/material/Fade'
import { Alert } from '@mui/material'

export enum SNACKBAR_VARIANTS {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
}

export interface ThemeSnackbarProps extends SnackbarProps {
  message: string
  snackbarOpen: boolean
  onClose: () => void
  variant?: SNACKBAR_VARIANTS
}

const ThemeSnackbar: React.FC<ThemeSnackbarProps> = ({
  message,
  snackbarOpen,
  variant = SNACKBAR_VARIANTS.info,
  onClose,
  ...rest
}): ReactElement => {
  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    setOpen(snackbarOpen)
  }, [snackbarOpen])

  return (
    <Snackbar
      open={open}
      sx={{ zIndex: 99999 }}
      onClose={() => {
        setOpen(false)
        onClose()
      }}
      TransitionComponent={Fade}
      {...rest}
    >
      <Alert severity={variant} sx={{ width: '100%' }} icon={false}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default ThemeSnackbar
